<div class="ts-prompt">
  <div class="ts-prompt__deck" aria-live="polite">
    <span class="ts-prompt__sheet ts-prompt__sheet--under" aria-hidden="true"></span>
    <span class="ts-prompt__sheet ts-prompt__sheet--middle" aria-hidden="true"></span>
    <!-- Before the card, so the card hides the fox's chin. -->
    <app-doodle kind="fox" class="ts-prompt__fox"></app-doodle>
    @for (t of [turn]; track t) {
      <figure class="ts-prompt__card">
        <p class="t-meta ts-prompt__genre">{{ prompt.genre }}</p>
        <blockquote class="ts-prompt__text">{{ prompt.text }}</blockquote>
        <figcaption class="t-caption ts-prompt__count">{{ index + 1 }} / {{ prompts.length }}</figcaption>
      </figure>
    }
  </div>

  <div class="ts-prompt__actions">
    @if (userIsLoggedIn) {
      <a class="ts-btn ts-btn--primary ts-btn--lg" [routerLink]="['/dashboard']">
        Start a new story <span class="ts-btn__arrow" aria-hidden="true">→</span>
      </a>
    } @else {
      <a class="ts-btn ts-btn--primary ts-btn--lg" [routerLink]="['/account/auth/signup']">
        Start your story <span class="ts-btn__arrow" aria-hidden="true">→</span>
      </a>
    }
    <button type="button" class="ts-btn ts-btn--ghost ts-btn--lg ts-prompt__shuffle" (click)="next()">
      <span class="ts-prompt__shuffle-icon" aria-hidden="true">↻</span> Another idea
    </button>
  </div>
</div>
